import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const EnumSchema = withDefaults({
  type: 'enum',
  fields: [
    {
      kind: 'attribute',
      name: 'flavor',
    },
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'dot',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'metadata',
    },
  ],
});

export default EnumSchema;
